/* =========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/
import MsButton from '@/components/button/MsButton.vue';
import MsSplitButton from '@/components/button/MsSplitButton.vue';
import MsDropDownButton from '@/components/button/MsDropDownButton.vue';
import MsInput from '@/components/input/MsInput.vue';
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue';
import MsRadio from '@/components/radio/MsRadio.vue';
import MsRadioGroup from '@/components/radio/MsRadioGroup.vue';
import MsDatepicker from '@/components/datepicker/MsDatePicker.vue';
import MsColorPicker from '@/components/colorpicker/MsColorPicker.vue';
import MsTextarea from '@/components/textarea/MsTextarea.vue';
import MsResizeWrapper from '@/components/resize-wrapper/MsResizeWrapper.vue';
// import VTooltip from "@/components/tooltip";
import MsNumber from '@/components/number/MsNumber.vue';
import MsComboboxTree from '@/components/combobox/MsComboboxTree.vue';
import MsComboBox from '@/components/combobox/MsCombobox.vue';
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum.vue';
import MsDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import MsHelpPopup from '@/components/popup/MsHelpPopup.vue';
import MsWorkbook from '@/components/workbook/MsWorkbook.vue';
import ToolbarWorkbook from '@/components/workbook/toolbar/ToolbarWorkbook.vue';
import ToolbarItemWorkbook from '@/components/workbook/toolbar/ToolbarItemWorkbook.vue';

// dialog workbook
import FindReplaceDialog from '@/components/workbook/dialog/FindReplaceDialog.vue';

import msCellState from '@/components/gridEditor/cellEditor/MsCellState.vue';
import msCellInput from '@/components/gridEditor/cellEditor/MsCellInput.vue';
import msCellComboboxMultiple from '@/components/gridEditor/cellEditor/MsCellComboboxMultiple.vue';
import msCellCombobox from '@/components/gridEditor/cellEditor/MsCellCombobox.vue';
import msCellComboboxEnum from '@/components/gridEditor/cellEditor/MsCellComboboxEnum.vue';
import msCellComboboxTree from '@/components/gridEditor/cellEditor/MsCellComboboxTree.vue';
import msCellNumber from '@/components/gridEditor/cellEditor/MsCellNumber.vue';
import msCellCheckbox from '@/components/gridEditor/cellEditor/MsCellCheckbox.vue';
import msCellDatepicker from '@/components/gridEditor/cellEditor/MsCellCheckbox.vue';
import msCellDropdown from '@/components/gridEditor/cellEditor/MsCellDropdown.vue';
import msCellAction from '@/components/gridEditor/cellEditor/MsCellAction.vue';
import { GcSpreadSheets } from '@grapecity/spread-sheets-vue';
import MsMultipleSelectButton from '@/components/button/MsMultipleSelectButton.vue';

import MsImage from '@/components/imageGalery/MsImage.vue';
import MsSafeHtml from '@/components/base/MsSafeHtml.vue';
import MsRichTextViewer from '@/components/base/MsRichTextViewer.vue';

import vClickOutSide from 'click-outside-vue3';
export function useComponents(app) {
  app.component('gc-spread-sheets', GcSpreadSheets);
  app.component(MsWorkbook.name, MsWorkbook);
  app.component(ToolbarWorkbook.name, ToolbarWorkbook);
  app.component(ToolbarItemWorkbook.name, ToolbarItemWorkbook);
  app.component(FindReplaceDialog.name, FindReplaceDialog);
  app.component(MsButton.name, MsButton);
  app.component(MsSplitButton.name, MsSplitButton);
  app.component(MsDropDownButton.name, MsDropDownButton);
  app.component(MsInput.name, MsInput);
  app.component(MsCheckbox.name, MsCheckbox);
  app.component(MsRadio.name, MsRadio);
  app.component(MsRadioGroup.name, MsRadioGroup);
  app.component(MsDatepicker.name, MsDatepicker);
  app.component(MsColorPicker.name, MsColorPicker);
  app.component(MsTextarea.name, MsTextarea);
  app.component(MsResizeWrapper.name, MsResizeWrapper);
  // app.use(VTooltip);
  app.use(vClickOutSide);
  app.component(MsNumber.name, MsNumber);
  app.component(MsComboBox.name, MsComboBox);
  app.component(MsComboBox.name, MsComboBox);
  app.component(MsComboboxEnum.name, MsComboboxEnum);
  app.component(MsComboboxTree.name, MsComboboxTree);
  app.component(MsDynamicPopup.name, MsDynamicPopup);
  app.component(MsHelpPopup.name, MsHelpPopup);
  app.component(MsMultipleSelectButton.name, MsMultipleSelectButton);

  app.component('msCellState', msCellState);
  app.component('msCellInput', msCellInput);
  app.component('msCellComboboxMultiple', msCellComboboxMultiple);
  app.component('msCellCombobox', msCellCombobox);
  app.component('msCellComboboxEnum', msCellComboboxEnum);
  app.component('msCellComboboxTree', msCellComboboxTree);
  app.component('msCellNumber', msCellNumber);
  app.component('msCellCheckbox', msCellCheckbox);
  app.component('msCellDatepicker', msCellDatepicker);
  app.component('msCellDropdown', msCellDropdown);
  app.component('msCellAction', msCellAction);
  app.component(MsImage.name, MsImage);
  // Components an toàn để phòng chống XSS
  app.component('MsSafeHtml', MsSafeHtml);
  app.component('MsRichTextViewer', MsRichTextViewer);
}
